import React from 'react';

import classes from './styles.module.scss';

export default function DefaultAvatar({
  firstName,
  lastName,
  width = 80,
  height = 80,
}) {
  return (
    <div className={classes.DefaultAvatar} style={{ width, height }}>
      {firstName && firstName[0]} {lastName && lastName[0]}
    </div>
  );
}
